module.exports = __webpack_public_path__ + "media/images/area/icon_weather_12-a057188e6a0ce91f2e4e44dcaf0e140c.png";